import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am a Computer Science student focused on designing and developing real world technology solutions.
              I have built and implemented projects in{" "}
              <span className="purple">web development and data analytics</span>, emphasizing scalability and performance.
              <br />
              <br />
              I am proficient in
              <i>
                <b className="purple">
                  {" "}
                  Python, JavaScript, SQL, and React{" "}
                </b>
              </i>{" "}
              and I apply these technologies to analyze data, develop applications, and optimize system performance.
              <br />
              <br />
              My core areas of interest include
              <i>
                <b className="purple">
                  {" "}
                  Data Analytics, Full Stack Development, and Data Visualization{" "}
                </b>
              </i>{" "}
              where I focus on building structured, data driven, and user centric solutions.
              <br />
              <br />
              I actively work on projects involving{" "}
              <b className="purple">algorithms, dashboards, and customer segmentation</b>, leveraging modern tools and frameworks such as{" "}
              <i>
                <b className="purple">React.js</b>
              </i>{" "}
              and{" "}
              <b className="purple">Python</b>.
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;